import React, { Component } from 'react';

const LOGO = 'https://s3.newworld.center/gif/58f7361f-aa31-4c21-92cc-ef84dcd0458f.gif';

const features = [
  { icon: '⚡', title: 'เข้าเล่นรวดเร็ว', desc: 'เปิดแอปเข้าเล่นได้ทันที ไม่ต้องเปิดเบราว์เซอร์' },
  { icon: '🔒', title: 'ปลอดภัยสูงสุด', desc: 'ระบบเข้ารหัสความปลอดภัยระดับธนาคาร' },
  { icon: '🎮', title: 'ครบทุกเกม', desc: 'คาสิโน สล็อต กีฬา ยิงปลา ครบในแอปเดียว' },
  { icon: '🔔', title: 'แจ้งเตือนโปร', desc: 'รับโปรโมชั่นและข่าวสารก่อนใคร' },
];

class DownloadPage extends Component {
  qrUrl() {
    const origin = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : 'https://pk8.com';
    return `https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=8&data=${encodeURIComponent(origin)}`;
  }

  dlBtn(label, sub, bg, mobile) {
    return (
      <button onClick={() => this.props && this.props.onDownload ? this.props.onDownload() : null}
        style={{
          display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', border: 'none',
          background: bg, color: '#fff', borderRadius: 12, padding: mobile ? '13px 18px' : '14px 26px',
          fontFamily: 'inherit', width: mobile ? '100%' : 'auto', justifyContent: mobile ? 'center' : 'flex-start',
          boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
        }}>
        <span style={{ fontSize: 26 }}>{label === 'iOS' ? '' : '🤖'}{label === 'iOS' ? '' : ''}</span>
        <span style={{ textAlign: 'left' }}>
          <span style={{ display: 'block', fontSize: 11, opacity: 0.85 }}>{sub}</span>
          <span style={{ display: 'block', fontSize: mobile ? 15 : 16, fontWeight: 700 }}>{label}</span>
        </span>
      </button>
    );
  }

  // ไอคอนดาวน์โหลดแอป (ลอกสไตล์ beta-app-download ของ bk8)
  appDownloadIcon(size) {
    return (
      <svg viewBox="0 0 90 90" width={size} height={size}>
        <defs>
          <linearGradient id="bk-appdl-grad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#095EBD" />
            <stop offset="1" stopColor="#04A9C2" />
          </linearGradient>
        </defs>
        {/* phone outline */}
        <rect x="23" y="14" width="44" height="68" rx="9" fill="#fff" stroke="url(#bk-appdl-grad)" strokeWidth="3.4" />
        {/* speaker */}
        <rect x="39" y="22.5" width="12" height="2.6" rx="1.3" fill="url(#bk-appdl-grad)" />
        {/* home button */}
        <circle cx="45" cy="75" r="3.1" fill="url(#bk-appdl-grad)" />
        {/* APP text */}
        <text x="45" y="44" textAnchor="middle" fontSize="13" fontWeight="800" fontFamily="Arial, sans-serif" fill="url(#bk-appdl-grad)">APP</text>
        {/* download arrow */}
        <line x1="45" y1="50" x2="45" y2="62" stroke="url(#bk-appdl-grad)" strokeWidth="2.7" strokeLinecap="round" />
        <path d="M40 57 L45 62.5 L50 57" fill="none" stroke="url(#bk-appdl-grad)" strokeWidth="2.7" strokeLinecap="round" strokeLinejoin="round" />
        {/* base tray */}
        <line x1="36" y1="68" x2="54" y2="68" stroke="url(#bk-appdl-grad)" strokeWidth="2.7" strokeLinecap="round" />
        {/* red notification badge */}
        <circle cx="64" cy="20" r="9" fill="#E0092C" />
        <path d="M64 15.6l1.2 2.5 2.7.4-2 1.9.5 2.7-2.4-1.3-2.4 1.3.5-2.7-2-1.9 2.7-.4z" fill="#fff" />
      </svg>
    );
  }

  render() {
    const mobile = window.innerWidth <= 760;
    return (
      <div style={{ background: '#0a1628', minHeight: '100vh', fontFamily: 'Noto Sans Thai, sans-serif', color: '#fff' }}>
        {/* Hero */}
        <div style={{ background: 'linear-gradient(135deg,#051030,#0d2348 60%,#1a3a6e)', padding: mobile ? '30px 20px 26px' : '56px 48px' }}>
          <div style={{ maxWidth: 1000, margin: '0 auto', display: 'flex', flexDirection: mobile ? 'column' : 'row', alignItems: 'center', gap: mobile ? 22 : 48 }}>
            <div style={{ flex: 1, textAlign: mobile ? 'center' : 'left' }}>
              <div onClick={() => this.props && this.props.onDownload ? this.props.onDownload() : null} style={{ display: 'inline-flex', marginBottom: 14, cursor: 'pointer', filter: 'drop-shadow(0 6px 16px rgba(4,169,194,.35))' }}>
                {this.appDownloadIcon(mobile ? 64 : 84)}
              </div>
              <div style={{ fontSize: mobile ? 12 : 14, color: '#f5a623', letterSpacing: 2, marginBottom: 6 }}>PK8 Application</div>
              <h1 style={{ fontSize: mobile ? 26 : 38, fontWeight: 800, margin: '0 0 10px' }}>ดาวน์โหลดแอป PK8</h1>
              <p style={{ fontSize: mobile ? 13.5 : 15, color: '#c8d6e5', lineHeight: 1.8, marginBottom: 20, maxWidth: 460, marginLeft: mobile ? 'auto' : 0, marginRight: mobile ? 'auto' : 0 }}>
                สัมผัสประสบการณ์เกมออนไลน์เต็มรูปแบบบนมือถือ เข้าเล่นง่าย ฝาก-ถอนไว ครบทุกเกมในแอปเดียว
              </p>
              <div style={{ display: 'flex', flexDirection: mobile ? 'column' : 'row', gap: 12, alignItems: 'center', justifyContent: mobile ? 'center' : 'flex-start' }}>
                {this.dlBtn('Android', 'ดาวน์โหลด APK', 'linear-gradient(135deg,#0a5ebd,#04a9c2)', mobile)}
                {this.dlBtn('iOS', 'ดาวน์โหลดสำหรับ', 'linear-gradient(135deg,#2a2f45,#3a4366)', mobile)}
              </div>
            </div>
            <div style={{ flex: '0 0 auto', textAlign: 'center' }}>
              <div style={{ background: '#fff', borderRadius: 18, padding: 14, display: 'inline-block' }}>
                <img src={this.qrUrl()} alt="QR Download" style={{ width: mobile ? 150 : 200, height: mobile ? 150 : 200, display: 'block' }} />
              </div>
              <div style={{ fontSize: 12.5, color: '#9fb3cc', marginTop: 10 }}>สแกน QR เพื่อดาวน์โหลด</div>
            </div>
          </div>
        </div>

        {/* App icon strip */}
        <div style={{ maxWidth: 1000, margin: '0 auto', padding: mobile ? '24px 20px 6px' : '36px 32px 10px', display: 'flex', alignItems: 'center', gap: 16, justifyContent: mobile ? 'center' : 'flex-start', flexWrap: 'wrap' }}>
          <img src={LOGO} alt="PK8" style={{ height: mobile ? 40 : 52 }} />
          <div>
            <div style={{ fontSize: mobile ? 16 : 18, fontWeight: 800 }}>PK8 Casino</div>
            <div style={{ fontSize: 12.5, color: '#f5a623' }}>★★★★★ 4.9 · รองรับ Android / iOS</div>
          </div>
        </div>

        {/* Features */}
        <div style={{ maxWidth: 1000, margin: '0 auto', padding: mobile ? '18px 14px 40px' : '24px 32px 56px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: mobile ? 'repeat(2,1fr)' : 'repeat(auto-fill, minmax(220px,1fr))', gap: mobile ? 12 : 18 }}>
            {features.map((f, i) => (
              <div key={i} style={{ background: '#0e2040', border: '1px solid #1e3560', borderRadius: 14, padding: mobile ? '18px 14px' : '22px 18px', textAlign: 'center' }}>
                <div style={{ fontSize: mobile ? 30 : 34, marginBottom: 10 }}>{f.icon}</div>
                <div style={{ fontSize: mobile ? 14 : 15, fontWeight: 700, marginBottom: 6 }}>{f.title}</div>
                <div style={{ fontSize: mobile ? 12 : 12.5, color: '#9fb3cc', lineHeight: 1.7 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default DownloadPage;
